import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function CheckIcon({ color, className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="44"
            viewBox="0 0 32 44"
            fill="none"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.266113 15.386C0.266113 7.0556 7.22039 0.240479 15.7204 0.240479C24.2221 0.240479 31.175 7.0556 31.175 15.386C31.175 26.7448 15.7204 43.5127 15.7204 43.5127C15.7204 43.5127 0.266113 26.7448 0.266113 15.386ZM15.7221 20.4287C14.7553 20.4292 13.8101 20.1385 13.0061 19.5934C12.202 19.0483 11.5753 18.2733 11.2052 17.3664C10.8351 16.4595 10.7383 15.4616 10.927 14.4988C11.1156 13.536 11.5813 12.6517 12.2652 11.9577C12.949 11.2638 13.8201 10.7914 14.7684 10.6003C15.7167 10.4092 16.6996 10.5081 17.5925 10.8843C18.4855 11.2606 19.2485 11.8973 19.7849 12.714C20.3214 13.5307 20.6071 14.4906 20.6061 15.4722C20.6055 16.7873 20.0907 18.0482 19.1749 18.9781C18.2591 19.9079 17.0172 20.428 15.7221 20.4287Z"
                fill={color}
            />
        </svg>
    );
}

CheckIcon.propTypes = propTypes;
CheckIcon.defaultProps = defaultProps;

export default CheckIcon;
